import React, { useState, useRef, useEffect } from "react";
import useAuth from "../../../../components/hooks/useAuth";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";
import ViewBroadcastAddLead from "./ViewBroadcastAddLead";
import { formatPhone } from "../../../../components/utils";
import ViewBroadcastUploadLeads from "./ViewBroadcastUploadLeads";


  const ViewBroadcastLeads = (props) => {

        const {broadcastId} = props;

  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();
  const fileInputRef = useRef(null);
  const [importMessage, setImportMessage] = useState('');
  const [leadSearch, setLeadSearch] = useState('');
  const [leads, setLeads] = useState([]);
  const [showAddLead, setShowAddLead] = useState(false);
  const [showUploadLead, setShowUploadLead] = useState(false);
  const [loading, setLoading] = useState(false);



  const removeLead = async (id) => {
    console.log(id)
    if(!id){
      return;
    }
    if(!window.confirm("Você realmente deseja excluir o numero "+formatPhone(leads.find(l => l.id === id).contact['phone_number']))){
      return;
    }
     setLoading(true);
    let contacts=[];
    contacts.push({'id':id});

     let response = await postApi("/api/v1/wpbroadcast/member/toggle/"+broadcastId, {
        'operation_type': 'del',
       contacts:contacts
      });
            listLeads();

  };

    



  useEffect(() => {

    const loadData = async () => {
      setLoading(true);
      listLeads();
    }

    loadData();

  }, [showUploadLead,showAddLead]);

    const listLeads = async () => {
    setLoading(true)
     let response = await getApi("/api/v1/wpbroadcast/members/"+broadcastId, {
      
      });

       if (response) {
        setLeads(response.lista);
       }
      setLoading(false)
  }
  


  return (
       <div style={{ padding: 16, borderRadius: 12, background: '#fff', boxShadow: '0 6px 20px rgba(0,0,0,0.04)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                    <div>
                      <div style={{ fontWeight: 700, color: '#222', marginBottom: 4 }}>Leads</div>
                      <div style={{ color: '#666', fontSize: 13 }}>Aqui aparecem os leads relacionados aos envios.</div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        onClick={() => setShowAddLead(true)}
                        style={{ padding: '8px 14px', borderRadius: 8, background: '#51a197', color: '#fff', border: 'none', fontWeight: 700, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}
                      >
                        <i className="bi bi-person-plus" style={{ fontSize: 16 }}></i>
                        ADICIONAR LEAD
                      </button>

                      <div>
                        <button
                          onClick={() => setShowUploadLead(true)}
                          style={{ display: 'inline-flex', alignItems: 'center', padding: '8px 14px', borderRadius: 8, background: '#51a197', color: '#fff', cursor: 'pointer', fontWeight: 700, gap: 8, border: 'none' }}
                        >
                          <i className="bi bi-file-earmark-arrow-up" style={{ fontSize: 16 }}></i>
                          ADICIONAR USANDO ARQUIVO
                        </button>
                      </div>
                    </div>
                  </div>
                  {importMessage && <div style={{ marginTop: 12, color: '#333' }}>{importMessage}</div>}

                  {/* Search and leads table */}
                  <div style={{ marginTop: 12 }}>
                    <input
                      type="search"
                      placeholder="Pesquisar por número"
                      value={leadSearch}
                      onChange={e => setLeadSearch(e.target.value)}
                      style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e0e0e0', marginBottom: 12 }}
                    />

                    <div style={{ borderRadius: 8, overflow: 'hidden', border: '1px solid #f0f0f0', background: '#fff' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ background: '#f8f9fa' }}>
                          <tr>
                            <th style={{ textAlign: 'left', padding: '10px 12px', fontSize: 14 }}>Número</th>
                            <th style={{ textAlign: 'right', padding: '10px 12px', fontSize: 14 }}>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {leads.filter(l => l.contact['phone_number'].replace(/\D/g, '').includes(leadSearch.replace(/\D/g, ''))).map(l => (
                            <tr key={l.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                              <td style={{ padding: '10px 12px' }}>{formatPhone(l.contact['phone_number'])}</td>
                              <td style={{ padding: '10px 12px', textAlign: 'right' }}>
                                <button disabled={loading} onClick={() => removeLead(l.id)} style={{ padding: '6px 10px', borderRadius: 8, background: '#fff', border: '1px solid #ff4d4f', color: '#ff4d4f', cursor: 'pointer', fontWeight: 700 }}>
                                  <i className="bi bi-trash" style={{ marginRight: 6 }}></i>Excluir
                                </button>
                              </td>
                            </tr>
                          ))}
                          {leads.length === 0 &&
                          !loading && (
                            <tr>
                              <td colSpan={2} style={{ padding: 12, color: '#666' }}>Nenhum lead cadastrado.</td>
                            </tr>
                          )}

                        </tbody>
                      </table>
                          {loading && <Loader />}
                    </div>
                  </div>

                  {showAddLead && (
               <ViewBroadcastAddLead broadcastId={broadcastId} showAddLead={showAddLead} setShowAddLead={setShowAddLead} />
              )}
                  {showUploadLead && (
               <ViewBroadcastUploadLeads broadcastId={broadcastId} showUploadLead={showUploadLead} setShowUploadLead ={setShowUploadLead } />
              )}
                </div>
          
  );
};

export default ViewBroadcastLeads;